'use strict';

/**
 * Functionality for the navigation bar.
 *
 * Browser full-screen functionality handles all browsers with
 * decent feature support (Chrome, Safari 6 and Firefox).
 *
 * In theory the full-screen API is supported on Safari 5 as well,
 * but it will be in presentation mode (no keyboard input allowed),
 * which kind of defeats the purpose of it. As such, we do not try
 * to cover support for Safari 5.
 */

angular.module('atex.art').controller('ArtNavbarCtrl',
['$scope', '$rootScope', '$location', '$q', '$route', '$modal', '$http', '$sce', 'ArtConfirmModal', 'ArtNotificationService', 'ArtContentStore',
  'ArtTemplateStore', 'ArtUserDataStore', 'AuthenticationService', 'ArtVersionService', 'Application', 'ArtSynchronizationService',
  'ArtListOptions', 'ArtLockingService', '$translate', 'ApplicationConfigurationService','UIConfigurationService', '$window',

  function($scope, $rootScope, $location, $q, $route, $modal, $http, $sce, ArtConfirmModal, ArtNotificationService, ArtContentStore,
           ArtTemplateStore, ArtUserDataStore, AuthenticationService, ArtVersionService, Application,
           ArtSynchronizationService, ArtListOptions, ArtLockingService, $translate, ApplicationConfigurationService, UIConfigurationService, $window) {

    $scope.locale = $translate.use();
    $scope.templates = [];
    $scope.currentUser = 'Unknown';
    $scope.syncInProgress = false;
    $scope.applicationVersion = 'Unknown';
    $scope.listView =  false;
    $scope.listOptions = ArtListOptions.listOptions;
    $scope.language = $translate.preferredLanguage() || $translate.negotiateLocale($translate.resolveClientLocale());

    $scope.crossSearchVisible = false;

    $scope.languages = {};
    $translate.getAvailableLanguageKeys().forEach(function(lang) {
      $scope.languages[lang]= {id:lang, name:$translate.instant("LANGUAGE_" + lang)};
    });

    ApplicationConfigurationService.getConfigurationFor(['language', 'showLanguageChoice'], true).then(function(show) {
      $scope.showLanguageChoice = show;
    });
    ApplicationConfigurationService.getConfigurationFor(['language','flagsEnabled'], true).then(function(enabled){
      $scope.flagsEnabled = enabled;
    });
    ApplicationConfigurationService.getConfigurationFor(['useACTInbox'], true).then(function(enabled){
      $scope.setUseInbox = enabled;
    });

    ArtVersionService.getVersion().then(function(version) {
      $scope.applicationVersion = version;
    }, function(error) {
      console.log('Error while reading application version:', error);
    });

    $rootScope.$on('$routeChangeSuccess', function (event, current, previous) {
      if (typeof current !== 'undefined' && typeof current.templateUrl !== 'undefined') {
        $scope.listView = current.templateUrl.indexOf('/list.html') > -1;
        $scope.detailsView = current.templateUrl.indexOf('/detail.html') > -1;
      }
    });

    $rootScope.$on('atex:cross-search-visible', function(event, visible) {
      $scope.crossSearchVisible = visible;
    });

    $rootScope.$on('$translateChangeSuccess', function (event, options) {
      $scope.language = options.language;
      $scope.languageText = $scope.languages[options.language].name;
    });

    $scope.$on('atex:synchronizationStart', function() {
      $scope.syncInProgress = true;
    });

    $scope.$on('atex:synchronizationEnd', function() {
      $scope.syncInProgress = false;
    });

    $rootScope.$on('$translateChangeSuccess', function () {
        $translate(['CONFIRM_HEADER', 'CANCEL_BTN', 'SIGN_OUT_MSG', 'SIGN_OUT','OPERATION_COMPLETED_SUCCESSFULLY','GENERIC_ERROR_MSG','PASSWORD_VALIDATION_MSG']).then(function (translations) {
            $scope.confirmHeader = translations.CONFIRM_HEADER;
            $scope.cancelButton = translations.CANCEL_BTN;
            $scope.signOutMessage = translations.SIGN_OUT_MSG;
            $scope.signOut = translations.SIGN_OUT;
            $scope.actSuccessMessage = translations.OPERATION_COMPLETED_SUCCESSFULLY;
            $scope.actErrorMessage = translations.GENERIC_ERROR_MSG;
            $scope.validationMessge = translations.PASSWORD_VALIDATION_MSG;
        });
    });

    var updateTemplates = function() {
      var deferred = $q.defer();

      ArtTemplateStore.getAll().then(function(templates) {
        UIConfigurationService.filter("templates", "act-templates", templates).then(function(_templates) {
          $scope.templates = _templates;
        });

        deferred.resolve();
      }, function(error) {
        console.log('ERROR: When updating template data:', error);
      });

      return deferred.promise;
    };

    var updateCurrentUser = function() {
      var deferred = $q.defer();

      AuthenticationService.getCurrentUser().then(function(currentUser) {
        return ArtUserDataStore.getById(currentUser.userId);
      }).then(function(userData) {
        Application.currentUser.userId = userData.aspects.contentData.data.id;
        Application.currentUser.username = userData.aspects.contentData.data.loginName;

        $scope.currentUser = userData.aspects.contentData.data.firstname || userData.aspects.contentData.data.loginName || userData.aspects.contentData.data.id;

        // TODO - This is not ideal, should be set by the application I think, but we need to have something
        // set in a rootScope so that user details can be used as expressions for default values.
        $rootScope.currentUser = userData;
        $rootScope.currentUser.fullName = $rootScope.currentUser.aspects.contentData.data.firstname + " " + $rootScope.currentUser.aspects.contentData.data.surname;

        deferred.resolve();
      }, function(error) {
        console.log('ERROR: When updating currentUser data:', error);
      });

      return deferred.promise;
    };

    updateCurrentUser().then(function() {
      return updateTemplates();
    });

    $scope.$on('onecms:authenticationSuccess', function() {
      updateCurrentUser();
    });

    $scope.$on('atex:synchronizationEnd', function() {
      updateCurrentUser().then(function() {
        return updateTemplates();
      });
    });

    $scope.notificationCount = function() {
      return ArtNotificationService.getNotificationLog().length;
    };

    $scope.hasFullscreen = function() {
      return screenfull.isEnabled;
    };

    $scope.toggleFullscreen = function() {
      if (!screenfull.isFullscreen) {
        screenfull.request();
      } else {
        screenfull.exit();
      }
    };

    $scope.requestNotificationCenter = function() {
      ArtNotificationService.displayNotificationCenter();
    };

    function getToken(username) {
      return $http({
        method: 'GET',
        url: '/insights-panel/insight/getTokenByAuthor/' + username,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }

    $scope.openUserProfile = function() {
      AuthenticationService.getCurrentUser().then(function (user) {
        getToken(user.username).then(function (info) {
          var data = atex.onecms.ObjectUtils.getByPath(info, "data/body");
          if (data) {
            var token = atex.onecms.ObjectUtils.getByPath(JSON.parse(data), "id");
            $window.open('/insights-panel/index.html?token=' + token + '&username=' + user.username, '_blank');
          }
        }).then(undefined, function (error) {
          var notification = atex.act.Notification({
            type: 'error',
            persistent: true,
            message: $scope.actErrorMessage
          });

          ArtNotificationService.addNotification(notification, false, function () {
          });
        });
      });
    };

    $scope.changePassword = function() {
      var modalScope = $scope.$new(true);

      var modal = $modal({
        show: true,
        scope: modalScope,

        template: 'templates/change-password-modal.html',
        modalClass: 'dam-change-password confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      modalScope.verified = (modalScope.confirm !== true);
      var deferred = $q.defer();

      function changePasswordApi(password) {
        return AuthenticationService.getCurrentUser().then(function (currentUser) {
          password = encodeURIComponent(password);
          var url = "/onecms/dam/content/changePassword?pwd=" + password;
          return $http({
            method: 'POST',
            url: url,
            headers: {
              'Content-Type': 'application/json',
              'X-Auth-Token': currentUser.token
            }
          });
        });
      }

      modalScope.matching = true;
      modalScope.valid = false;
      modalScope.weak = false;
      modalScope.type = "password";

      var strong = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
      var medium = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            modalScope.$destroy();
            modalEl.remove();
          });

          modalEl.modal('hide');
        });
      };

      modalScope.showPopover = function () {
        var left = Math.round($('#change-password-modal').width() / 3.4);
        $('.change-passwd-info').css('left', left);
        $('.change-passwd-info').show();
      };

      modalScope.hidePopover = function () {
        $('.change-passwd-info').hide();
      };

      modalScope.check = function () {
        if (!modalScope.weak) {
          if (modalScope.password && modalScope.confirm) {
            modalScope.matching = modalScope.valid = (modalScope.password === modalScope.confirm);
          } else if (modalScope.password && !modalScope.confirm) {
            modalScope.matching = true;
            modalScope.valid = false;
          } else if (!modalScope.confirm && !modalScope.password) {
            modalScope.matching = true;
            modalScope.valid = false;
          } else {
            modalScope.matching = false;
            modalScope.valid = false;
          }
        }
      };

      modalScope.showPassword = function () {
        modalScope.type = modalScope.type === 'text' ? 'password' : 'text';
      };

      modalScope.validate = function () {
        if (strong.test(modalScope.password)) {
          modalScope.passwdStatus = "green";
          modalScope.weak = false;
        } else if (medium.test(modalScope.password)) {
          modalScope.passwdStatus = "orange";
          modalScope.weak = true;
        } else {
          modalScope.passwdStatus = "red";
          modalScope.weak = true;
        }
      };

      modalScope.to_trusted = function() {
        if ($scope.validationMessge) {
          return $sce.trustAsHtml($scope.validationMessge);
        }
      };

      modalScope.doClose = function () {
        destroyModal();
        deferred.resolve("close");
      };

      modalScope.doSave = function () {
        changePasswordApi(modalScope.password).then(function () {
          ArtNotificationService.addNotification(atex.act.Notification({
            type: 'success',
            message: $scope.actSuccessMessage
          }), false);
          modalScope.doClose();
        }).then(null, function () {
          ArtNotificationService.addNotification(atex.act.Notification({
            type: 'error',
            message: $scope.actErrorMessage
          }), true);
        });
      };

      return deferred.promise;
    };

    function unlockAll() {
      if($rootScope.editChain && $rootScope.editChain.get(0)) {
        var article = $rootScope.editChain.get(0);
        return ArtLockingService.unlockAll(article);
      } else {
        return $q.when();
      }
    }

    $scope.requestLogout = function() {
      if ($scope.syncInProgress) {
        console.log("Sync in progress, ignoring logout request...");
        return;
      }

      ArtContentStore.getAll().then(function(content) {
        var modifiedContent = content.filter(function(o) { return o.local.persisted === false; });

        if (modifiedContent.length > 0) {
          var confirmModal = ArtConfirmModal.create({
            confirmHeader: $scope.confirmHeader,
            confirmBody: $scope.signOutMessage,
            cancel: $scope.cancelButton,
            ok: $scope.signOut,
            mode: 'danger'
          });

          confirmModal.then(function(confirmed) {
            if (confirmed) {
              unlockAll().then(function (){
                $scope.logout();
              });
            }
          });
        } else {
          unlockAll().then(function (){
            $scope.logout();
          });
        }
      });
    };

    $scope.hide = function() {
      var templateUrls = ['views/detail.html','views/autosave.html'];

      var hide = false;
      if($route.current) {
        var templateUrl = $route.current.templateUrl;
        hide = (templateUrls.indexOf(templateUrl) > -1);
      }

      return hide;
    };

    $scope.logout = function() {
      $window.atex.analytics('event', { e: 'logout' });
      $window.atex.analytics('reset');

      ArtSynchronizationService.disableAutoSync();

      Application.reset();

      localStorage.removeItem('act.user.associatedSites');
      localStorage.removeItem('act.user.taxonomyIds');

      ArtNotificationService.clearAllToasts();
      ArtNotificationService.clearNotificationLog();

      $scope.currentUser = 'Unknown';

      if (typeof $rootScope !== 'undefined') {
        $rootScope.$broadcast('atex:logout');
      }

      atex.GenericStore(atex.act.AngularUtils.applyingQ($q, $scope)).getInternals().clearAndInitializeDatabase().then(function() {
        $rootScope.$broadcast('atex:contentSynchronized');

        return ArtSynchronizationService.synchronize(true);
      }).then(function() {
        var reloadPath = '/';
        var reloadRequired = ($location.path() === reloadPath);

        $location.path(reloadPath);

        if (reloadRequired) {
          $route.reload();
        }
      });
    };

    $scope.changeLanguage = function(lang) {

      $location.search('locale', null);
      $scope.locale = lang;
      $translate.use(lang).then($route.reload());
    };


  }
]);
